import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/es.uint8-array.set-from-base64.js";
import "core-js/modules/es.uint8-array.set-from-hex.js";
import "core-js/modules/es.uint8-array.to-base64.js";
import "core-js/modules/es.uint8-array.to-hex.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import service from "@/services/service";
// import commonService from "@/commonService/index";

import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
export default {
  name: "upload",
  components: {
    VueCropper
  },
  inject: {
    elForm: {
      default: ""
    },
    elFormItem: {
      default: ""
    }
  },
  data() {
    return {
      expVisible: false,
      avatar: "",
      isLoading: false,
      cropedImg: "",
      visible: false,
      picVisible: false,
      zIndex: false
    };
  },
  component: {
    VueCropper
  },
  computed: {
    commonStyle() {
      return {
        width: this.imgWidth,
        height: this.imgHeight,
        borderRadius: `${this.round ? "50%" : "4px"}`
      };
    },
    coverStyle() {
      return {
        ...this.commonStyle,
        alignItems: "flex-end"
      };
    },
    avatarBoxStyle() {
      return {
        ...this.commonStyle,
        borderWidth: "1px",
        borderColor: this.value || this.defaultImg ? "#efefef" : "#999",
        borderStyle: this.value || this.defaultImg ? "solid" : "dashed"
      };
    },
    isShowCover() {
      return this.value;
    }
  },
  props: {
    value: String,
    defaultImg: {
      type: String,
      default: ""
    },
    allowDelete: {
      type: Boolean,
      default: true
    },
    accept: {
      type: String,
      default: "image/gif,image/jpeg,image/jpg,image/png"
    },
    standardImgUrl: {
      type: [String, Number],
      default: ""
    },
    imgUrl: {
      type: [String, Number],
      default: ""
    },
    imgWidth: {
      type: [String, Number],
      default: ""
    },
    imgHeight: {
      type: [String, Number],
      default: ""
    },
    tip: {
      type: [String, Number],
      default: ""
    },
    name: {
      type: [String, Number],
      default: ""
    },
    round: {
      type: Boolean,
      default: false
    },
    autoCropHeight: {
      type: [String, Number],
      default: 100
    },
    autoCropWidth: {
      type: [String, Number],
      default: 100
    },
    fixedNumber: {
      type: [Array],
      default: () => {
        return ["16:9"];
      }
    },
    maxSize: {
      type: Number,
      default: 8
    },
    isCropper: {
      type: Boolean,
      default: false
    },
    defaultTipsTxt: {
      type: String,
      default: "添加图片"
    },
    validateEvent: {
      type: Boolean,
      default: true
    },
    iconSize: {
      type: Number,
      default: 26
    },
    disabled: {
      type: Boolean,
      default: false
    },
    acceptImgWidth: {
      type: Number,
      default: 0
    },
    acceptImgHeight: {
      type: Number,
      default: 0
    }
  },
  watch: {
    value(val) {
      this.avatar = val;
      this.$emit("change");
      if (!val) {
        this.cropedImg = "";
      }
      if (this.validateEvent && this.elFormItem) {
        this.elFormItem.validate("change");
      }
      this.clearValue();
    },
    visible(val) {
      if (!val) {
        this.clearValue();
      }
    }
  },
  methods: {
    changeCrop(obj) {
      console.log(obj);
    },
    handleInput() {
      console.log(this.name);
      this.$refs[`avatarInput${this.name}`].click();
    },
    //clear input filie value
    clearValue() {
      this.$refs[`avatarInput${this.name}`].value = "";
    },
    async changeImage(e) {
      let file = e.target.files[0];
      console.log("changeImage", file);
      if (file) {
        const isLt8M = file.size / 1024 / 1024 < this.maxSize;
        if (!this.accept.replace(/\s/g, "").split(",").includes(file.type)) {
          this.clearValue();
          this.$message.warning("请选择正确的图片格式");
          return;
        }
        if (!file.type.includes("image/")) {
          this.clearValue();
          this.$message.warning("请选择图片文件");
          return;
        }
        if (!isLt8M) {
          this.clearValue();
          this.$message.error(`上传的图片大小不能超过 ${this.maxSize}MB!`);
          return;
        }
        if (this.acceptImgWidth || this.acceptImgHeight) {
          let imgInfo = await new Promise((resolve, reject) => {
            const img = new Image();
            img.src = URL.createObjectURL(file);
            img.onload = function () {
              console.log(`Width: ${img.width}, Height: ${img.height}`);
              URL.revokeObjectURL(img.src); // 释放URL对象
              resolve({
                width: img.width,
                height: img.height
              });
            };
          });
          if (imgInfo) {
            if (imgInfo.height != this.acceptImgHeight) {
              this.$message.error(`当前图片高度为${imgInfo.height},要求高度为${this.acceptImgHeight}`);
              return;
            }
            if (imgInfo.width != this.acceptImgWidth) {
              this.$message.error(`当前图片宽度为${imgInfo.width},要求宽度为${this.acceptImgWidth}`);
              return;
            }
          }
        }

        // 文件对象
        if (this.isCropper) {
          this.visible = true;
          if (typeof FileReader === "function") {
            const reader = new FileReader();
            reader.onload = event => {
              this.cropedImg = event.target.result;
              this.$refs.cropper.replace(event.target.result);
            };
            reader.readAsDataURL(file);
          } else {
            this.handleUpload(file);
          }
        } else {
          this.handleUpload(file);
        }
      }
    },
    handleUpload(file) {
      this.isLoading = true;
      let formData = new FormData();
      formData.append("file", file);
      this.$service.commonService.uploadImg(formData).then(res => {
        this.isLoading = false;
        if (res.code == 200 && res.data) {
          let data = res.data;
          this.avatar = data.url;
          this.$emit("input", data.url);
          this.$emit("upload-success", data, this.name);
        }
      });
    },
    handleCropper() {
      this.visible = false;
      let data = this.$refs.cropper.getCroppedCanvas().toDataURL("image/jpeg", 0.7);
      let blob = this.dataURLtoBlob(data);
      this.handleUpload(blob);
    },
    //base64 to blob
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
        type: mime
      });
    },
    handleRemove() {
      this.clearValue();
      this.$emit("input", "");
      this.$emit("on-remove", this.name);
    },
    preview() {
      this.picVisible = true;
    },
    handleOpenReview() {
      this.zIndex = true;
      let maskList = document.querySelectorAll(".el-image-viewer__mask");
      let domImageCloseList = document.querySelectorAll(".el-image-viewer__close");
      if (!domImageCloseList.length > 0 && !maskList.length > 0) {
        return;
      }
      [].forEach.call(domImageCloseList, item => {
        item.addEventListener("click", () => {
          setTimeout(() => {
            this.zIndex = false;
          }, 500);
        });
      });
      [].forEach.call(maskList, item => {
        item.addEventListener("click", () => {
          [].forEach.call(domImageCloseList, it => {
            it.click();
          });
        });
      });
    }
  }
};